import { defineMessages } from '@jutro/locale';

export default defineMessages({
    Drivers: {
        id: 'ml-gateway.views.policy-summary.Drivers',
        defaultMessage: 'Drivers'
    },
    ExcludedDrivers: {
        id: 'ml-gateway.views.policy-summary.Excluded Drivers',
        defaultMessage: 'Excluded Drivers'
    },
    HouseholdMembers: {
        id: 'ml-gateway.views.policy-summary.Household Members',
        defaultMessage: 'Household Members'
    },
    NonDrivers: {
        id: 'ml-gateway.views.policy-summary.Non Drivers',
        defaultMessage: 'Non Drivers'
    },
    Vehicles: {
        id: 'ml-gateway.views.policy-summary.Vehicles',
        defaultMessage: 'Vehicles'
    },
    VehicleExposures: {
        id: 'ml-gateway.views.policy-summary.Vehicle Exposures',
        defaultMessage: 'Vehicle Exposures'
    },
    Name: {
        id: 'ml-gateway.views.policy-summary.Name',
        defaultMessage: 'Name'
    },
    DOB: {
        id: 'ml-gateway.views.policy-summary.DOB',
        defaultMessage: 'Date of Birth'
    },
    Gender: {
        id: 'ml-gateway.views.policy-summary.Gender',
        defaultMessage: 'Gender'
    },
    MaritalStatus: {
        id: 'ml-gateway.views.policy-summary.Marital Status',
        defaultMessage: 'Marital Status'
    },
    License: {
        id: 'ml-gateway.views.policy-summary.Drivers License',
        defaultMessage: 'Drivers License'
    },
    RelationshipToInsured: {
        id: 'ml-gateway.views.policy-summary.Relationship to Insured',
        defaultMessage: 'Relationship to Insured'
    },
    ReasonNotListed: {
        id: 'ml-gateway.views.policy-summary.Reason Not Listed',
        defaultMessage: 'Reason Not Listed'
    },
    NotIncluded: {
        id: 'ml-gateway.views.policy-summary.Not Included',
        defaultMessage: 'Not Included'
    },
    Included: {
        id: 'ml-gateway.views.policy-summary.Included',
        defaultMessage: 'Included'
    },
    InsuredInfo: {
        id: 'ml-gateway.views.policy-summary.Insureds Information',
        defaultMessage: 'Insured\'s Information'
    },
    Primary: {
        id: 'ml-gateway.views.policy-summary.Primary',
        defaultMessage: ' (primary)'
    },
    TransactionDiffPopupTitle: {
        id: 'ml-gateway.views.policy-summary.TransactionDiffPopupTitle',
        defaultMessage: 'Select Policy Effective Dates to Compare'
    },
    TransactionDiffListPopupTitle: {
        id: 'ml-gateway.views.policy-summary.TransactionDiffListPopupTitle',
        defaultMessage: 'Your Comparison'
    },
    PolicyDate: {
        id: 'ml-gateway.views.policy-summary.Policy Date',
        defaultMessage: 'Policy Date: '
    },
    Compare: {
        id: 'ml-gateway.views.policy-summary.Compare',
        defaultMessage: 'Compare'
    },
    CompareTerm: {
        id: 'ml-gateway.views.policy-summary.Compare Term',
        defaultMessage: 'Compare Term'
    },
    Cancel: {
        id: 'ml-gateway.views.policy-summary.Cancel',
        defaultMessage: 'Cancel'
    },
    Close: {
        id: 'ml-gateway.views.policy-summary.Close',
        defaultMessage: 'Close'
    },
    PrimaryInsured: {
        id: 'ml-gateway.views.policy-summary.Primary Insured',
        defaultMessage: 'Primary Insured'
    },
    CoInsured: {
        id: 'ml-gateway.views.policy-summary.CoInsured',
        defaultMessage: 'Co-Insured'
    },
    SameAddress: {
        id: 'ml-gateway.views.policy-summary.Same as Primary Insured',
        defaultMessage: 'Same as Primary Insured'
    },
    LocationExposures: {
        id: 'ml-gateway.views.policy-summary.Locations',
        defaultMessage: 'Locations'
    },
    UnderlyingInsurance: {
        id: 'ml-gateway.views.policy-summary.Required Minimum Underlying Insurance',
        defaultMessage: 'Required Minimum Underlying Insurance'
    },
    ULLimit: {
        id: 'ml-gateway.views.policy-summary.ULLIMIT',
        defaultMessage: 'EACH PERSON / OCCURRENCE OR SINGLE LIMIT'
    },
    ULType: {
        id: 'ml-gateway.views.policy-summary.UNDERLYING POLICY TYPE',
        defaultMessage: 'UNDERLYING POLICY TYPE'
    },
    Year: {
        id: 'ml-gateway.views.policy-summary.Year',
        defaultMessage: 'Year'
    },
    Make: {
        id: 'ml-gateway.views.policy-summary.Make',
        defaultMessage: 'Make'
    },
    Model: {
        id: 'ml-gateway.views.policy-summary.Model',
        defaultMessage: 'Model'
    },
    Trim: {
        id: 'ml-gateway.views.policy-summary.Trim',
        defaultMessage: 'Trim'
    },
    Vin: {
        id: 'ml-gateway.views.policy-summary.Vin',
        defaultMessage: 'Vin'
    },
    RelationshiptoPrimaryInsured: {
        id: 'ml-gateway.views.policy-summary.Relationship to Primary Insured',
        defaultMessage: 'Relationship to Primary Insured'
    },
    AgeFirstLicensed: {
        id: 'ml-gateway.views.policy-summary.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    },
    Occupation: {
        id: 'ml-gateway.views.policy-summary.Occupation',
        defaultMessage: 'Occupation'
    },
    Coverage: {
        id: 'ml-gateway.views.policy-summary.Coverage',
        defaultMessage: 'Coverage'
    },
    Total: {
        id: 'ml-gateway.views.policy-summary.Total',
        defaultMessage: 'Total'
    },
    Limit: {
        id: 'ml-gateway.views.policy-summary.Limit',
        defaultMessage: 'Limit'
    },
    LimitAndDeductible: {
        id: 'ml-gateway.views.policy-summary.Limit and Deductible',
        defaultMessage: 'Limit & Deductible'
    },
    Limits: {
        id: 'ml-gateway.views.policy-summary.Limits',
        defaultMessage: 'Limits'
    },
    Premium: {
        id: 'ml-gateway.views.policy-summary.Premium',
        defaultMessage: 'Premium'
    },
    UmbrellaCoverage: {
        id: 'ml-gateway.views.policy-summary.Umbrella Coverage',
        defaultMessage: 'Umbrella Coverage'
    },
    OptionalCoverages: {
        id: 'ml-gateway.views.policy-summary.Optional Coverages',
        defaultMessage: 'Optional Coverages'
    },
    Exclusions: {
        id: 'ml-gateway.views.policy-summary.Exclusions',
        defaultMessage: 'Exclusions'
    },
    GoodStudent: {
        id: 'ml-gateway.views.policy-summary.Good Student',
        defaultMessage: 'Good Student'
    },
    ResidentStudent: {
        id: 'ml-gateway.views.policy-summary.Resident Student',
        defaultMessage: 'Resident Student'
    },
    NameofSchool: {
        id: 'ml-gateway.views.policy-summary.Name of School',
        defaultMessage: 'Name of School'
    },
    RequireProofofFinancialResponsibility: {
        id: 'ml-gateway.views.policy-summary.Require Proof of Financial Responsibility',
        defaultMessage: 'Require Proof of Financial Responsibility'
    },
    CertificateEffectiveDate: {
        id: 'ml-gateway.views.policy-summary.Certificate Effective Date',
        defaultMessage: 'Certificate Effective Date'
    },
    CaseNumber: {
        id: 'ml-gateway.views.policy-summary.Case Number',
        defaultMessage: 'Case Number'
    },
    Yes: {
        id: 'ml-gateway.views.policy-summary.Yes',
        defaultMessage: 'Yes'
    },
    No: {
        id: 'ml-gateway.views.policy-summary.No',
        defaultMessage: 'No'
    },
    MortgageCompany: {
        id: 'ml-gateway.views.policy-summary.Mortgage Company',
        defaultMessage: 'Mortgage Company'
    },
    LeasingCompany: {
        id: 'ml-gateway.views.policy-summary.Leasing Company',
        defaultMessage: 'Leasing Company'
    },
    LeinholderCompany: {
        id: 'ml-gateway.views.policy-summary.Leinholder Company',
        defaultMessage: 'Leinholder Company'
    },
    LessorCompany: {
        id: 'ml-gateway.views.policy-summary.Lessor Company',
        defaultMessage: 'Lessor Company'
    },
    AdditionalInsured: {
        id: 'ml-gateway.views.policy-summary.Additional Insured',
        defaultMessage: 'Additional Insured'
    },
    Trust: {
        id: 'ml-gateway.views.policy-summary.Trust',
        defaultMessage: 'Trust'
    },
    ThirdParty: {
        id: 'ml-gateway.views.policy-summary.Third Party',
        defaultMessage: 'Third Party'
    },
    JointOwnership: {
        id: 'ml-gateway.views.policy-summary.Joint Ownership',
        defaultMessage: 'Joint Ownership'
    },
    AdditionalInterest: {
        id: 'ml-gateway.views.policy-summary.Additional Interest',
        defaultMessage: 'Additional Interest'
    },
    CondoAssociation: {
        id: 'ml-gateway.views.policy-summary.Condo Association',
        defaultMessage: 'Condo Association'
    },
    GaragedAt: {
        id: 'ml-gateway.views.policy-summary.Garaged At',
        defaultMessage: 'Garaged At'
    },
    AnnualMileage: {
        id: 'ml-gateway.views.policy-summary.Annual Mileage',
        defaultMessage: 'Annual Mileage'
    },
    Value: {
        id: 'ml-gateway.views.policy-summary.Value',
        defaultMessage: 'Value'
    },
    VehicleCoverages: {
        id: 'ml-gateway.views.policy-summary.Vehicle Coverages',
        defaultMessage: 'Vehicle Coverages'
    },
    Coverages: {
        id: 'ml-gateway.views.policy-summary.Coverages',
        defaultMessage: 'Coverages'
    },
    Deductible: {
        id: 'ml-gateway.views.policy-summary.Deductible',
        defaultMessage: 'Deductible'
    },
    LossSettlement: {
        id: 'ml-gateway.views.policy-summary.Loss Settlement',
        defaultMessage: 'Loss Settlement'
    },
    Type: {
        id: 'ml-gateway.views.policy-summary.Type',
        defaultMessage: 'Type'
    },
    Description: {
        id: 'ml-gateway.views.policy-summary.Description',
        defaultMessage: 'Description'
    },
    City: {
        id: 'ml-gateway.views.policy-summary.City',
        defaultMessage: 'City'
    },
    State: {
        id: 'ml-gateway.views.policy-summary.State',
        defaultMessage: 'State'
    },
    Address: {
        id: 'ml-gateway.views.policy-summary.Address',
        defaultMessage: 'Address'
    },
    BusinessActivityExposures: {
        id: 'ml-gateway.views.policy-summary.Business Activity',
        defaultMessage: 'Business Activity'
    },
    WatercraftExposures: {
        id: 'ml-gateway.views.policy-summary.Watercraft Exposures',
        defaultMessage: 'Watercraft Exposures'
    },
    WatercraftOperators: {
        id: 'ml-gateway.views.policy-summary.Watercraft Operators',
        defaultMessage: 'Watercraft Operators'
    },
    ItemType: {
        id: 'ml-gateway.views.policy-summary.Item Type',
        defaultMessage: 'Item Type'
    },
    TotalLimit: {
        id: 'ml-gateway.views.policy-summary.Total Limit',
        defaultMessage: 'Total Limit'
    },
    PerItem: {
        id: 'ml-gateway.views.policy-summary.Per Item',
        defaultMessage: 'Per Item'
    },
    ValuableProperty: {
        id: 'ml-gateway.views.policy-summary.Valuable Personal Property',
        defaultMessage: 'Valuable Personal Property'
    },
    SpecialLimitations: {
        id: 'ml-gateway.views.policy-summary.Special Limitations',
        defaultMessage: 'Special Limitations'
    },
    SpecialLimitationsPara: {
        id: 'ml-gateway.views.policy-summary.Special Limitations Para',
        defaultMessage: 'These categories are covered up to the dollar amount and/or loss.'
    },
    VehicleTotal: {
        id: 'ml-gateway.views.policy-summary.Vehicle Total',
        defaultMessage: 'Vehicle Total'
    },
    CoverageTotal: {
        id: 'ml-gateway.views.policy-summary.Coverage Total',
        defaultMessage: 'Coverage Total'
    },
    MonthTerm: {
        id: 'ml-gateway.views.policy-summary.Month Term',
        defaultMessage: '/month'
    },
    SixMonthTerm: {
        id: 'ml-gateway.views.policy-summary.Six Month Term',
        defaultMessage: '/6 month'
    },
    YearTerm: {
        id: 'ml-gateway.views.policy-summary.Year Term',
        defaultMessage: '/year'
    },
    Discounts: {
        id: 'ml-gateway.views.policy-summary.Discounts',
        defaultMessage: 'Discounts'
    },
    IncludedFeatures: {
        id: 'ml-gateway.views.policy-summary.Included Features',
        defaultMessage: 'Included Features'
    },
    Excluded: {
        id: 'ml-gateway.views.policy-summary.Excluded',
        defaultMessage: 'Excluded'
    },
    ExclusionsPara: {
        id: 'ml-gateway.views.policy-summary.Exclusions Para',
        defaultMessage: 'You\'ve selected to exclude coverage for the following:'
    },
    delinquencyWarning: {
        id: 'ml-gateway.views.policy-summary.delinquencyWarning',
        defaultMessage: 'A cancellation for non-payment of premium is pending on policy {policyNumber}. This policy will cancel unless outstanding premium is paid.'
    },
    conversionWarning: {
        id: 'ml-gateway.views.policy-summary.conversionWarning',
        defaultMessage: '<b>Important Reminder:</b> This Foremost Signature policy is scheduled for conversion to a new Farmers policy in Guidewire Policy Center {policyNumber}.  <b>If you make any changes to a Foremost Signature policy, you must also make those same changes to the pending Farmers policy in Guidewire.</b>  Policy changes will not automatically be updated. If you have any questions, please search Ask Service Ops. Thank you for assistance.'
    },
    AddressLine1: {
        id: 'ml-gateway.views.policy-summary.AddressLine1',
        defaultMessage: 'Address Line 1'
    },
    AddressLine2: {
        id: 'ml-gateway.views.policy-summary.AddressLine2',
        defaultMessage: 'Address Line 2'
    },
    ZipCode: {
        id: 'ml-gateway.views.policy-summary.ZipCode',
        defaultMessage: 'Zip Code'
    },
    NumberOfFamilies: {
        id: 'ml-gateway.views.policy-summary.NumberOfFamilies',
        defaultMessage: 'Number Of Families'
    },
    DescriptionOfProperty: {
        id: 'ml-gateway.views.policy-summary.DescriptionOfProperty',
        defaultMessage: 'Description Of Property'
    },
    TypeOfProperty: {
        id: 'ml-gateway.views.policy-summary.TypeOfProperty',
        defaultMessage: 'Type Of Property'
    },
    HomeownersAssociation: {
        id: 'ml-gateway.views.policy-summary.Homeowners Association',
        defaultMessage: 'Homeowners Association'
    },
    MineSubTitle: {
        id: 'ml-gateway.views.policy-summary.MineSubTitle',
        defaultMessage: 'Mine Subsidence Insurance - Scheduled Private Structure'
    },
    MineSubDescriptionOfProperty: {
        'id': 'ml-gateway.views.policy-summary.MineSubDescriptionOfProperty',
        'defaultMessage': 'Description Of Property'
    },
    MineSubLimit: {
        'id': 'ml-gateway.views.policy-summary.MineSubLimit',
        'defaultMessage': 'Limit'
    },
    MineSubDeductible: {
        'id': 'ml-gateway.views.policy-summary.MineSubDeductible',
        'defaultMessage': 'Deductible'
    },
    MineSubIsLocatedOnPremise: {
        'id': 'ml-gateway.views.policy-summary.MineSubIsLocatedOnPremise',
        'defaultMessage': 'Is the scheduled structure located on the primary insured premises?'
    },
    rentedTDCVehicles: {
        'id': 'ml-gateway.views.policy-summary.Rented Trailer / Camper',
        'defaultMessage': 'Rented Trailer / Camper'
    },
    serialNumber: {
        'id': 'ml-gateway.views.policy-summary.SERIAL NUMBER',
        'defaultMessage': 'SERIAL NUMBER'
    },
    namedNonOwner: {
        id: 'ml.gateway.policySummaryDetails.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    },
    namedNonOwnerNP:{
        id:'ml.gateway.policySummaryDetails.Named Non-OwnerNP',
        defaultMessage: 'Non Owner'
    },
   mercerErrorMessage: {
        id:'ml.gateway.policySummaryDetails.mercerErrorMessage',
        defaultMessage: 'Policy is serviced by mercer. Any servicing request should be refered to mercer for handling {custServicingPhoneNumber}'
    },
    firstPersonInControl: {
        id:'ml.gateway.policySummaryDetails.firstPersonInControl',
        defaultMessage: 'First Person in Control'
    },
    secondPersonInControl: {
        id: 'ml.gateway.policySummaryDetails.secondPersonInControl',
        defaultMessage: 'Second Person in Control'
    },
});
